<template>
	<section id="colecoes">
		<div class="container">
			<div class="title">MINHA CONTA</div>
			<div class="dados">
				<div class="foto"><img alt="Foto do perfil" src="http://portaldoaluno.webaula.com.br//FotosPersonagem/fotoDefaultAluno.jpg"></div>
				<div class="descricao">
					<div>{{ $auth.user().nome }}</div>
					<div>{{ $auth.user().email }}</div>
					<div>Perfil: {{$auth.user().nomePerfil }}</div>
					<button class="btn-edit" @click="edit"><i class="fas fa-edit"></i>ALTERAR SENHA</button>
				</div>
				<div class="box-totalizadores">
					<div class="totalizadores">
						<div class="items">
							<span class="item"><i class="fas fa-heart"></i> {{totalDeFaboritos}} Favoritos</span>
							<span class="item"><i class="fas fa-folder"></i> {{totalDeColecoes}} Coleções</span>
						</div>
					</div>
				</div>
			</div>
			<div class="collections">
				<div class="menu">
					<div class="box-menu">
						<router-link :to="{ name: 'minhasColecoes' }" :class="{ 'activated': $route.name === 'minhasColecoes' }">
							<span class="txt-menu">Visualizar coleções</span>
						</router-link>
						<hr>
						<router-link :to="{ name: 'meusFavoritos' }" :class="{ 'activated': $route.name === 'meusFavoritos' }">
							<span class="txt-menu">Visualizar favoritos</span>
						</router-link>
					</div>
				</div>
				<div class="box-colecoes">
					<router-view></router-view>
				</div>
			</div>
			<CadastrarColecao @boxCreate="createCollection" :boxCadastro="boxCadastro" v-if="boxCadastro"/>
			<!-- Modal -->
			<ModalEdit v-show="isModalVisible">
				<template v-slot:body>
					<form @submit.prevent>
						<div class="row full">
							<div>
								<label>Usuario:</label>
								<input type="text" v-model="nome" disabled/>
							</div>
						</div>
						<div class="row">
							<div>
								<label>Email:</label>
								<input type="text" v-model="email" disabled/>
							</div>
							<div>
								<label>Senha Atual:</label>
								<input type="password" placeholder="Senha Atual" v-model="data.senhaAtual"/>
							</div>
						</div>
						<div class="row">
							<div>
								<label>Nova Senha:</label>
								<input type="password" placeholder="Nova senha" v-model="data.novaSenha"/>
							</div>
							<div>
								<label>Confirmar Nova Senha:</label>
								<input type="password" placeholder="Confirme a nova senha" v-model="confirmarSenha"/>
							</div>
						</div>
						<span class="error" v-show="msg">{{msg}}</span>
						<div class="actions">
							<button @click="cancelar">CANCELAR</button>
							<button @click="alterarnovaSenha">SALVAR</button>
						</div>
					</form>
				</template>
			</ModalEdit>
			<!-- Final modal -->
		</div>
	</section>
</template>

<script>
import ModalEdit from '@/components/shared/ModalEdit'
import CadastrarColecao from '@/components/views/colecoes/inc/CadastrarColecao'
import { usuarios } from '@/services/usuarios'
export default {
	name: 'Colecoes',
	components: { CadastrarColecao, ModalEdit },
	data () {
		return {
			boxCadastro: false,
			data: {
				id: this.$auth.user().id,
				novaSenha: '',
				senhaAtual: ''
			},
			confirmarSenha: '',
			isModalVisible: false,
			nome: '',
			email: '',
			totalDeFaboritos: 0,
			totalDeColecoes: 0,
			msg: ''
		}
	},
	methods: {
		createCollection (boxCreate) {
			this.boxCadastro = boxCreate
		},
		async edit () {
			this.isModalVisible = true
		},
		cancelar () {
			this.isModalVisible = false
			this.data.novaSenha = ''
			this.data.senhaAtual = ''
			this.confirmarSenha = ''
			this.msg = ''
		},
		async alterarnovaSenha () {
			if (this.data.senhaAtual === '' && this.data.novaSenha) {
				this.msg = 'Senha Atual não pode ser vazia.'
				return false
			}
			if ((this.confirmarSenha !== '' && this.data.novaSenha !== '')) {
				try {
					await usuarios.alterPassword(this.data)
					this.cancelar()
				} catch (error) {
					this.msg = 'A Senha atual está diferente.'
				}
			} else {
				this.msg = 'Nova senha e confirmar nova senha precisa ser iguais.'
				return false
			}
		}
	},
	async created () {
		const usuario = await usuarios.find(this.$auth.user().id)
		this.nome = usuario.data.nome
		this.email = usuario.data.email
		this.totalDeFaboritos = usuario.data.totalDeFaboritos
		this.totalDeColecoes = usuario.data.totalDeColecoes
	}
}
</script>

<style lang="scss" scoped>
	#colecoes {
		font: Condensed 16px Roboto;
		margin-top: 120px;
		color: #fff;

		@media all and (max-width: 700px) {
			& {
				margin-top: 0 !important;
			}
		}

		.container {
			.title {
				font-family: "Roboto Condensed","Roboto",sans-serif;
				font-size: 24px;
				font-weight: bold;
				color: #fff;
				text-transform: uppercase;
				margin-bottom: 23px;
			}
			.dados {
				border: 2px solid #21344D;
				background-color: #061529;
				border-radius: 10px;
				display: flex;
				.foto {
					padding: 20px;
					img {
						border-radius: 100%;
						width: 180px;
						height: 180px;
						border: 5px solid #21344D;
					}
				}
				.descricao {
					display: flex;
					flex-direction: column;
					justify-content: center;
					div:first-child {
						font-size: 21px;
					}
					div:nth-child(2n) {
						font: Condensed 16px/26px Roboto;
						color: #E2E41A;
					}
					div:last-child {
						font: Condensed Light Italic 14px/26px Roboto;
						color: #FFFFFF;
					}
					.btn-edit {
						margin-top:21px;
						background-color: #00659D;
						color:#FFFFFF;
						border-radius: 5px;
						padding: 7px 26px 7px 14px;
						border:none;
						text-transform: uppercase;
						font: Condensed Bold 15px Roboto;
						cursor: pointer;

						i {
							margin-right: 12px;
						}
					}
				}
				.box-totalizadores {
					display: flex;
					justify-content: center;
					align-items: center;
					width:70%;

					.totalizadores {
						padding: 30px 45px;
						border-left: 2px solid #21344D;
						color:#59708F;

						.items {
							display: grid;
							grid-template-columns: repeat(2, 200px);
							grid-template-rows: repeat(2, 20px);
							.item {
								display:flex;
								align-items: center;
								i {
									font-size: 30px;
									margin-right: 10px;
								}
							}
						}
					}
				}
			}

			.likes {
				.card_list {
					display: flex;
					flex-wrap: nowrap;
					justify-content: space-between;
					margin-bottom: 10px;

					@media all and (max-width: 1366px) {
						display: grid;
						grid-template-columns: repeat(3, 1fr);
						grid-gap: 10px 10px;

						@media all and (max-width: 700px) {
							& {
								grid-template-columns: repeat(2, 1fr);
							}

							@media all and (max-width: 500px) {
								& {
									grid-template-columns: 1fr;
								}
							}
						}
					}
				}

				.likes_actions {
					text-align: center;

					button {
						width: 300px;
						padding: 15px 25px;
						border: none;
						border-radius: 5px;
						background-color: #00659D;
						color: #FFF;
						text-transform: uppercase;
						font-size: 16px;
						letter-spacing: .5px;
						font-family: 'Roboto Condensed', 'Roboto', sans-serif;
						font-weight: bold;
						margin-top: 30px;
						cursor: pointer;
					}
				}
			}

			.collections {
				display: flex;
				justify-content: space-between;
				.menu {
					width:18%;
					padding-top: 40px;
					.box-menu {
						display:flex;
						flex-direction: column;
						padding:20px 30px;
						background-color: rgba(6, 22, 43, 0.8);

						a {
							color: #FFFFFF;

							&:link, &:visited {
								text-decoration: none;
							}
							&:hover, &.activated {
								color:#E2E41A;
							}
						}

						.txt-menu {
							font-size: 20px;
							margin-top:10px;
							margin-bottom: 10px;
							font-family: Roboto;
						}

						hr{
							border: 1px solid #D1D1D1;
							width: 100%;
							opacity: 0.15;
						}
					}
				}
				.box-colecoes {
					width:80%;
					.collections_actions {
						text-align: center;

						button {
							width: 300px;
							padding: 12px 25px;
							border: none;
							border-radius: 5px;
							background-color: #00659D;
							color: #FFF;
							text-transform: uppercase;
							font-size: 16px;
							letter-spacing: .5px;
							font-family: 'Roboto Condensed', 'Roboto', sans-serif;
							font-weight: bold;
							margin-top: 30px;
							cursor: pointer;
						}
					}
				}
			}
		}
		form {
			width: 100%;
			background-color: #fff;
			padding: 15px;
			margin-top: 50px;
			.row {
				display: flex;
				margin: 0 auto;
				justify-content: space-between;
				margin-top: 35px;
				label {
					display: block;
					display: flex;
					justify-content: left;
					margin-bottom: 5px;
					color: #052354;
					font-weight: bold;
				}
				input {
					height: 40px;
					width: 300px;
					padding-left: 6px;
				}
			}
			.full {
				input {
					width: 634px;
				}
			}
		}
		.dataDisable {
			margin-bottom: 50px;
		}
		.error {
			color: #f00;
			margin: 0px 0px 0px 0;
		}
		.actions {
			margin-top: 40px;
			display: flex;
			justify-content: flex-end;
			button:first-child {
				margin-right: 10px;
				background-color: #fff;
				color: #000;
				border: 1px solid #06162B;
			}
			button:nth-child(2n) {
				background-color: #00659D;
				color: #fff;
				border: 1px solid #00659D;
			}
			button {
				border-radius: 5px;
				height: 47px;
				width: 136px;
				font-weight: bold;
			}
		}
	}
</style>
